<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none center" to="/">
      <p class="c-sidebar-brand-full pt-4">CMS LP WEB</p>
      <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>
    <CRenderFunction
      flat
      :content-to-render="dataNav"
      v-if="credential === 'ADMIN' || credential === 'ADMINISTRATOR'"
    />
    <CRenderFunction
      flat
      :content-to-render="dataNav"
      v-if="credential === 'NPOS'"
    />
    <CRenderFunction
      flat
      :content-to-render="$options.SALES"
      v-if="credential === 'SALES'"
    />
    <CRenderFunction
      flat
      :content-to-render="$options.MARKETING"
      v-if="credential === 'MARKETING'"
    />
    <CRenderFunction
      flat
      :content-to-render="$options.COMMUNITY"
      v-if="credential === 'COMMUNITY'"
    />
    <CRenderFunction
      flat
      :content-to-render="$options.HRD"
      v-if="credential === 'HRD'"
    />
    <CRenderFunction
      flat
      :content-to-render="$options.QC"
      v-if="credential === 'QC'"
    />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('sidebarMinimize', !minimize)"
    />
  </CSidebar>
</template>

<script>
import QC from "./QC";
import HRD from "./HRD";
import COMMUNITY from "./COMMUNITY";
import MARKETING from "./MARKETING";
import SALES from "./SALES";
import { AdminMenuList } from "./ADMIN";
import { NPOSLeadMenuList } from "./NPOS_LEAD";
import { NPOSStaffMenuList } from "./NPOS_STAFF";
import axios from "axios";
import jwt from "jsonwebtoken";
import ACCOUNT_GROUP from "../app/enum/groups.js";

export default {
  name: "TheSidebar",
  SALES,
  MARKETING,
  COMMUNITY,
  HRD,
  QC,
  data() {
    return {
      accountData: {},
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      credential: "",
      postion: "",
      dataNav: [],
    };
  },
  mounted() {
    this.authorizationToken();
    this.getDataAmountInformation();
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  methods: {
    authorizationToken() {
      const token = jwt.decode(localStorage.getItem("token"));
      this.credential = token.account_group;
      this.position = token.position;
    },
    getDataAmountInformation() {
      axios
        .get(`${this.domain}/v2/agent/data/amount/information`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.setNavAmountInformation(response.data.data);
        })
        .catch((e) => {
          if (e.name === "Error") {
            let ammountInformation = {
              new: 0,
              follow_up: 0,
              top_up: 0,
              listing: 0,
            };
            this.setNavAdmin(ammountInformation);
          }
        });
    },
    //atribute nav set in here becouse if credential admin , adminsitrator nav have data amount status information
    setNavAmountInformation(ammountInformation) {
      if (ammountInformation.new >= 100) {
        ammountInformation.new = "99+";
      }

      if (ammountInformation.follow_up >= 100) {
        ammountInformation.follow_up = "99+";
      }

      if (ammountInformation.top_up >= 100) {
        ammountInformation.top_up = "99+";
      }

      if (ammountInformation.listing >= 100) {
        ammountInformation.listing = "99+";
      }

      var menuList = [];

      if (this.credential === ACCOUNT_GROUP.ADMIN || this.credential === ACCOUNT_GROUP.ADMINISTRATOR) {
        menuList = AdminMenuList(ammountInformation);
      } else if (this.credential === ACCOUNT_GROUP.NPOS) {
        if (this.position === ACCOUNT_GROUP.LEAD) {
          menuList = NPOSLeadMenuList(ammountInformation);
        } else if (this.position === ACCOUNT_GROUP.STAFF) {
          menuList = NPOSStaffMenuList(ammountInformation);
        }
      }

      this.dataNav.push(menuList);
    },
  },
};
</script>
